export const TOOLTIP_OFFSET = { top: -20, left: 12 };
export const Y_AXIS_LABEL_OFFSET = 24;

// Shared by the scale's nice() and the axis, so the top of the domain is always
// a tick the axis actually draws.
export const Y_AXIS_NUM_TICKS = 6;

export const LEGEND_SWATCH_WIDTH = 18;
export const LEGEND_SWATCH_HEIGHT = 12;
export const LEGEND_SWATCH_STROKE_WIDTH = 2;

// The end-of-line badges ride the domain-padding runway inside the plot, so the
// right margin only gives the last axis label room to centre. The top margin is a
// header band: marker labels ride its upper row, the spike callouts its lower row.
// The top is sized for one marker row; a stacked label grows it by another.
export const CONCURRENCY_CHART_MARGIN = {
  top: 44,
  right: 32,
  bottom: 40,
  left: 50,
};

// Baselines relative to the plot top, so negative reaches up into the top margin.
export const MARKER_LABEL_Y = -28;
export const SPIKE_LABEL_MIN_Y = -8;

export const MARKER_LINE_TOP_Y = MARKER_LABEL_Y + 6;

// A marker label that would collide with another one rides a row above it, so the
// rows stack upwards and every marker line still starts below all of them. Two
// labels collide when they would keep less than the gap between them.
export const MARKER_LABEL_ROW_HEIGHT = 16;
export const MARKER_LABEL_GAP = 8;

export const REFERENCE_BADGE_HEIGHT = 20;
export const REFERENCE_BADGE_PADDING_X = 4;
// Approximate advance width of a p-body4 character, so a badge can hug its text
// without a DOM measure pass.
export const REFERENCE_BADGE_CHAR_WIDTH = 6.2;

export const X_RANGE_PADDING = 4;

// A bar covers just over half its day, leaving a visible gap on either side, and
// never thins below a couple of pixels on a long cycle.
export const DAY_BAND_WIDTH_RATIO = 0.55;
export const MIN_DAY_BAND_WIDTH = 2;

// The API only returns in-cycle days, so the left side just gets breathing room
// while the right needs enough runway for the cycle-end marker and its badge.
export const DOMAIN_PADDING_LEFT_DAYS = 1;
export const DOMAIN_PADDING_RIGHT_DAYS = 4;

// Below this width the plot stops shrinking and the container scrolls instead,
// keeping the axis date labels from colliding.
export const MIN_PLOT_WIDTH = 480;

export const SPIKE_LABEL_OFFSET = 6;

// Approximate advance width of a spike callout's character — wider than the badge's
// because of the arrow glyph — plus the gap kept between two callouts.
export const SPIKE_LABEL_CHAR_WIDTH = 8;
export const SPIKE_LABEL_GAP = 4;

// Ticks are phase-aligned to the cycle, so its start and end always land on one.
export const AXIS_CYCLE_SEGMENTS = 5;

// The markers are told apart by their header labels, not by line style.
export const MARKER_DASH = "6,3";
export const MARKER_STROKE_WIDTH = 1.5;
export const MARKER_LABEL = { cycleStart: "Cycle start", cycleEnd: "Cycle end", today: "Today" };
